import script from "./detalhe.vue?vue&type=script&lang=js"
export * from "./detalhe.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__